import { Link, useLocation } from 'react-router-dom'
import { buttonVariants } from '@/components/ui/Button'
import { PageHeader } from '@/components/ui/PageHeader'

/** An unknown address inside the admin (WP-05): it says so instead of silently opening the
 *  dashboard, and offers the way back. Rendered inside the shell, so the rail stays usable. */
export function NotFound() {
  const { pathname } = useLocation()
  return (
    <div>
      <PageHeader
        title="Такой страницы нет"
        description={`Адрес ${pathname} не найден — возможно, раздел переименован.`}
      />
      <Link to="/" className={buttonVariants({ variant: 'primary' })}>
        На дашборд
      </Link>
    </div>
  )
}
